import cx from 'classnames';
import { ELSFlex, ELSFlexItem, ELSIcon } from 'components/common/els';
import './warning.card.scss';

export interface WarningCardProps {
  className?: string;
  message: string;
}

const WarningCard = (props: WarningCardProps) => {
  const { className, message } = props;
  return (
    <div className={cx('c-els-card c-els-card--small c-els-card--border-negative', className)}>
      <ELSFlex className="warning-card" id="warning-card-center" left>
        <ELSFlexItem className="warning-card__icon">
          <ELSIcon name="alert" prefix="gizmo" color="warn" />
        </ELSFlexItem>
        <ELSFlexItem className="u-els-bold u-els-margin-left">{message}</ELSFlexItem>
      </ELSFlex>
    </div>
  );
};

WarningCard.displayName = 'WarningCard';
export default WarningCard;
